import React from "react";
import { Banner, ResponsiveLayout, Typography } from "@bca/ui-library";

interface BannerProps {
  closeBanner: () => void;
}

const HPIErrorBanner: React.FunctionComponent<BannerProps> = ({
  closeBanner,
}) => {
  return (
    <ResponsiveLayout
      px="0px"
      css={`
        position: relative;
        z-index: 1;
        top: inherit;
      `}
    >
      <Banner
        variant="warning"
        title="Service currently unavailable"
        primaryLinkLabel="Close"
        primaryLinkAction={closeBanner}
        paddingY={20}
        position="static"
      >
        <Typography margin={0} variant="body" color="grey-blue">
          Sorry, we’re unable to retrieve HPI Spec Check information at the
          moment.
        </Typography>
      </Banner>
    </ResponsiveLayout>
  );
};

export default HPIErrorBanner;
